// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button Styles */
.report-button {
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 16px;
    border-radius: 8px;
    cursor: pointer;
    margin-right: 12px;
    transition: background-color 0.3s ease;
  }
  
  .report-button:hover {
    background-color: var(--primary-color);
  }
  
  .report-button:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
  }
  
  /* Input Styles */
  .secure-code-input {
    width: 225px;
    margin-top: 12px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  
  /* Generate Button Style */
  .generate-secure-report-button {
    background-color: var(--primary-color);
    color: white;
    padding: 8px;
    border: none;
    border-radius: 8px;
    margin-left: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .generate-secure-report-button:hover {
    background-color: #28a745;
  }
  
  /* Modal Content Scroll */
  .modal-content {
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
    color: #ff6600; /* Orange */
    margin-bottom: 10px;
  }
  
  .section-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #ddd;
  }
  
  .label {
    color: #444;
    font-size: 14px;
  }
  
  .value {
    color: #ff6600; /* Orange */
    font-weight: bold;
    font-size: 14px;
  }
  
  .no-data {
    color: #888;
    font-size: 14px;
    font-style: italic;
  }

  .main-container {
    height: 100vh;
    overflow: scroll;
  }`, "",{"version":3,"sources":["webpack://./src/pages/reports/reports.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAE,WAAW;IAC3B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc,EAAE,WAAW;IAC3B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB","sourcesContent":["/* Button Styles */\n.report-button {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    margin-right: 12px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .report-button:hover {\n    background-color: var(--primary-color);\n  }\n  \n  .report-button:disabled {\n    background-color: #d1d5db;\n    cursor: not-allowed;\n  }\n  \n  /* Input Styles */\n  .secure-code-input {\n    width: 225px;\n    margin-top: 12px;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n  }\n  \n  /* Generate Button Style */\n  .generate-secure-report-button {\n    background-color: var(--primary-color);\n    color: white;\n    padding: 8px;\n    border: none;\n    border-radius: 8px;\n    margin-left: 20px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .generate-secure-report-button:hover {\n    background-color: #28a745;\n  }\n  \n  /* Modal Content Scroll */\n  .modal-content {\n    max-height: 80vh;\n    overflow-y: auto;\n  }\n  \n  .section-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: #ff6600; /* Orange */\n    margin-bottom: 10px;\n  }\n  \n  .section-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .row {\n    display: flex;\n    justify-content: space-between;\n    padding: 6px 0;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .label {\n    color: #444;\n    font-size: 14px;\n  }\n  \n  .value {\n    color: #ff6600; /* Orange */\n    font-weight: bold;\n    font-size: 14px;\n  }\n  \n  .no-data {\n    color: #888;\n    font-size: 14px;\n    font-style: italic;\n  }\n\n  .main-container {\n    height: 100vh;\n    overflow: scroll;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
